import { render, staticRenderFns } from "./quiz-question-answer.html?vue&type=template&id=c13d3076&scoped=true&"
import script from "./quiz-question-answer.js?vue&type=script&lang=js&"
export * from "./quiz-question-answer.js?vue&type=script&lang=js&"
import style0 from "./quiz-question-answer.scss?vue&type=style&index=0&id=c13d3076&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13d3076",
  null
  
)

export default component.exports